<template>
	<div>
		<table>
			<thead>
				<tr class="body-text-1">
					<th class="th-question__type" @click="sortColumn('name')">
						<div class="th-sort">
							<span> {{ $t('careerCluster') }} </span>
							<span v-if="sortedColumn === 'name'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr v-for="(row, index) in careersData" :key="index" class="table-row">
					<td class="td-cluster-name">
						<span class="td-span" @click="toggleAccordion(index)">{{
							row.name
						}}</span>
						<table v-if="expandedRowIndex === index" class="table-career">
							<thead>
								<tr class="body-text-1">
									<th class="th-question__checkbox">
										<input
											v-show="false"
											type="checkbox"
											class="checkbox"
											:checked="!isDeselectedAll"
											@input="deselectAllItems(index)"
										/>
									</th>
									<th class="th-question__type">
										{{ $t('cmsCareers') }}
									</th>
									<th class="th-question__actions"></th>
								</tr>
							</thead>
							<tr class="search-row">
								<td></td>
								<td class="td-input">
									<label class="custom-input">
										<svgicon name="search"> </svgicon>
										<input
											v-model="searchCareerClusterName"
											@input="displayedData"
										/>
									</label>
								</td>
								<td class="th-question__actions"></td>
							</tr>
							<tr v-for="(detail, i) in row.cmsCareers" :key="i">
								<td class="th-question__checkbox">
									<input
										type="checkbox"
										class="checkbox"
										:checked="detail.isActive"
										@input="isActiveItem(index, i)"
									/>
								</td>
								<td class="td-cluster-name">
									<span
										class="td-span"
										@click="toggleAccordionJobTitles(detail.career_ID, i)"
										>{{ detail.name }}</span
									>
									<table
										v-if="expandedDetailIndex === i"
										class="table-job-title"
									>
										<thead>
											<tr class="body-text-2">
												<th class="th-question__titles">
													{{ $t('jobTitle') }}
												</th>
												<th class="th-question__titles">
													{{ $t('lifeStage') }}
												</th>
												<th class="th-question__actions"></th>
											</tr>
										</thead>
										<tr v-for="(careerJob, ind) in careerJobTitles" :key="ind">
											<td>{{ careerJob.jobTitle }}</td>
											<td>{{ getLifeStageName(careerJob.lifeStage_ID) }}</td>
											<td>
												<button class="action-button" @click="editRow(detail)">
													<svgicon name="pencil"></svgicon>
												</button>
												<button class="action-button">
													<svgicon
														name="search"
														@click="searchRow(row)"
													></svgicon>
												</button>
											</td>
										</tr>
									</table>
								</td>
								<td class="td-center">
									<button class="action-button" @click="editRow(detail)">
										<svgicon name="pencil"></svgicon>
									</button>
									<button class="action-button">
										<svgicon name="search" @click="searchRow(row)"></svgicon>
									</button>
								</td>
							</tr>
						</table>
					</td>
					<td class="td-center">
						<button class="action-button" @click="editRowCareer(row)">
							<svgicon name="pencil"></svgicon>
						</button>
						<button class="action-button">
							<svgicon name="search" @click="searchRow(row)"></svgicon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="data.length"
			@changePage="setAllPage"
		></ja-pagination>
	</div>
</template>
<script>
import Pagination from '@/components/AdminSection/elements/Pagination';
import CareerServices from '@/services/cms/CareerServices';
import { lifeStageDropdown } from '@/helpers/constants';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import '@/components/icons/cms/arrowDown';
import '@/components/icons/cms/arrowUp';

export default {
	components: {
		jaPagination: Pagination
	},
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			sortedColumn: null,
			sortOrder: 1,
			isSorted: false,
			searchCareerClusterName: '',
			currentPage: 1,
			itemsPerPage: 250,
			careerClusterNameIndex: 0,
			expandedRowIndex: null,
			expandedDetailIndex: null,
			careerJobTitles: [],
			isDeselectedAll: false,
			careersData: null,
			lifeStageOptions: lifeStageDropdown
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.careersData.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		}
	},
	mounted() {
		this.careersData = this.data;
	},
	methods: {
		deselectAllItems(index) {
			this.isDeselectedAll = false;
			this.careersData[index].cmsCareers.forEach(
				item => (item.isActive = false)
			);
			this.editRowClusters(this.careersData[index]);
			this.isDeselectedAll = true;
		},
		isActiveItem(index, i) {
			this.careersData[index].cmsCareers.forEach((item, idx) => {
				if (idx === i) {
					this.$emit('deleteCareer', item.career_ID);
				}
			});

			this.isDeselectedAll = false;
		},
		getLifeStageName(lifeStageID) {
			const lifeStage = this.lifeStageOptions.find(
				stage => stage.lifeStage_ID === lifeStageID
			);
			return lifeStage ? lifeStage.name : '';
		},
		toggleAccordion(index) {
			if (this.expandedRowIndex === index) {
				this.expandedRowIndex = null;
				this.expandedDetailIndex = null;
			} else {
				this.expandedRowIndex = index;
			}
		},
		displayedData() {
			let filteredData = this.data.map(row => {
				const filteredCareers = row.cmsCareers.filter(job =>
					job.name
						.toLowerCase()
						.includes(this.searchCareerClusterName.toLowerCase())
				);
				return {
					...row,
					cmsCareers: filteredCareers
				};
			});
			const start = (this.currentPage - 1) * this.itemsPerPage;
			filteredData = filteredData.slice(start, start + this.itemsPerPage);
			this.careersData = filteredData;
			return filteredData;
		},
		async toggleAccordionJobTitles(careerId, index) {
			const data = await CareerServices.getCareerJobTitlesById(careerId);
			this.careerJobTitles = data;
			if (this.expandedDetailIndex === index) {
				this.expandedDetailIndex = null;
			} else {
				this.expandedDetailIndex = index;
			}
		},
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
			this.isSorted = !this.isSorted;
			if (this.sortedColumn) {
				this.careersData.sort((a, b) => {
					const fieldA = a[this.sortedColumn].toLowerCase();
					const fieldB = b[this.sortedColumn].toLowerCase();
					return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
				});
			}
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		editRow(row) {
			const careerClusterName = this.careersData.filter(
				data => data.careerCluster_ID === row.careerCluster_ID
			);
			row.careerClusterName = careerClusterName[0].name;
			this.$emit('editRow', row);
		},
		editRowCareer(row) {
			this.$emit('editRowCareer', row);
		},
		editRowClusters(cluster) {
			this.$emit('editCareerCluster', cluster);
		},
		setAllPage(page) {
			this.currentPage = page;
		},
		searchRow(row) {
			this.$emit('observeRowCareer', row);
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 10px;
}
.td-input {
	padding: 0;
}
.th-question {
	&__checkbox {
		padding: 0 15px;
		width: 5%;
	}
	&__type {
		width: 80%;
	}
	&__actions {
		width: 12%;
	}
	&__titles {
		width: 35%;
	}
}
.td-center {
	display: flex;
	align-content: flex-start;
	flex-wrap: wrap;
}

.custom-input {
	display: flex;
	border-radius: 4px;
	border: 1px solid #ddd;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
	padding: 7px 5px;
	margin: 1px;
	gap: 5px;
}

.custom-input input {
	border: none;
	outline: none;
	width: 100%;
}
.custom-input:focus-within {
	outline: 2px solid $hover-state;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
}
.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}
.th-sort {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}

.td-span {
	width: 100%;
	display: flex;
	cursor: pointer;
	height: 100%;
	padding: 5px;
	margin-left: 15px;
}
.td-cluster-name {
	padding: 0px;
}
.table-career {
	width: 98%;
	margin: auto;
	margin-bottom: 5px;
}
.table-job-title {
	margin: auto;
	width: 90%;
	margin-bottom: 15px;
	margin-top: 15px;
}
</style>
